export default __webpack_public_path__ + "static/youtubeImg-d4ce4ca63861978717d196c19702da1c.png";